import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import state from '@bingads-webui-component-legacy/state/index';
import dateUtil from '@bingads-webui-component-legacy/humanize/date';
import _ from 'underscore';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import { cardPerformanceId, cardRecommendationsId, cardDeviceId, cardTopAccountsId, cardTopChangesAccountId } from '@bingads-webui-campaign/fluent-page-consts';

export function fetchDataForAccountsOverview({
  serverContext,
  resolve,
  reject,
}) {
  Promise.all([
    import(/* webpackMode: 'eager' */ '@bingads-webui-campaign/overview-panel'),
    import(/* webpackMode: 'eager' */ '@bingads-webui-campaign/fluent-page-data'),
    import(/* webpackMode: 'eager' */ '@bingads-webui-campaign/overview-cards-common'),
    import(/* webpackMode: 'eager' */ '@bingads-webui-campaign-legacy/dashboard-cards/tips-card/data-fetch'),
    import(/* webpackMode: 'eager' */ '@bingads-webui-component-legacy/preference/service/index'),
    import(/* webpackMode: 'eager' */ '@bingads-webui-static-legacy/instrumentation/index'),
    import(/* webpackMode: 'eager' */ '@bingads-webui-component-legacy/js-data-campaign/index'),
  ])
    .then(([
      { DateFilterState },
      {
        getFluentCardsConfigs, getInitSelectedCardsConfig, getViewPortCardsCount, isInViewPort, getCardPreferenceOptionsForDfm,
      },
      { fetchAggregatedData },
      { fetchMCCOverviewRecommendations },
      { default: preference },
      { instrumentation },
      { default: jsdata },
    ]) => {
      preference
        .initialize()
        .then(() => {
          const permissions = {
            ...serverContext.Permissions || {},
            dynamic: serverContext.DynamicPermissions || {},
          };

          const p$DateRange = new DateFilterState({ state }).p$State;
          const cardsConfigs = getFluentCardsConfigs({ permissions });

          const selectedCardsConfig = getInitSelectedCardsConfig({
            preference,
            cardsConfigs,
            navigationLevel: 'customer',
            serverContext,
            isSDK: false,
          });

          const cardIds = _.map(selectedCardsConfig, 'typeId');
          const viewPortCardSize = getViewPortCardsCount(selectedCardsConfig);

          const getCardsConfig = () =>
            selectedCardsConfig.map(config =>
              getCardPreferenceOptionsForDfm({
                config,
                navigationLevel: 'customer',
                preference,
                permissions,
              }));

          window.FluentOverviewPageDataFetchManagerCardsConfigObject = {
            config: getCardsConfig(),
            viewPortCardSize,
            innerHeight: window.innerHeight,
            innerWidth: window.innerWidth,
          };

          const isPerformanceInViewPort = isInViewPort(cardIds, cardPerformanceId, viewPortCardSize);
          const isRecommendationInViewPort = isInViewPort(cardIds, cardRecommendationsId, viewPortCardSize);
          const isDeviceInViewPort = isInViewPort(cardIds, cardDeviceId, viewPortCardSize);
          const isTopAccountsInViewPort = isInViewPort(cardIds, cardTopAccountsId, viewPortCardSize);
          const isTopChangesAccountInViewPort = isInViewPort(cardIds, cardTopChangesAccountId, viewPortCardSize);

          // If no cards are in viewport, resolve and return
          if (!(isPerformanceInViewPort || isRecommendationInViewPort || isDeviceInViewPort || isTopAccountsInViewPort || isTopChangesAccountInViewPort)) {
            resolve();
            return;
          }

          edm.customerIdType.useAdvertiserCustomerId = false;
          const entitySet = edm.currentCustomer.Accounts;

          p$DateRange
            .then((dateRange) => {
              if (isPerformanceInViewPort || isDeviceInViewPort || isTopAccountsInViewPort || isTopChangesAccountInViewPort) {
                fetchAggregatedData({
                  entitySet,
                  navigationLevel: 'customer',
                  dateRange,
                  jsdata,
                  dateUtil,
                  getCardsConfig,
                  instrumentation,
                  constants,
                  permissions,
                });
              }

              if (isRecommendationInViewPort) {
                fetchMCCOverviewRecommendations({
                  entitySet: edm.currentCustomer.Accounts,
                });
              }

              resolve();
            })
            .catch((error) => {
              console.error('Error fetching date range:', error);
              reject(error);
            });
        }).catch((error) => {
          console.error('Error initializing preference service:', error);
          reject(error);
        });
    })
    .catch((error) => {
      console.error('Error loading modules:', error);
      reject(error);
    });
}
